import React from 'react'
import { COLORS } from 'theme'
import Avatar from 'components/Avatar'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import {
  SecondaryHeading,
  StyledP,
  GreyText,
  SecondGreyText,
  SubFLex,
  EditorContent,
} from 'modules/Resume/Style/style'
import moment from 'moment'
const AwardsSection = ({ studentDetails }) => {
  return (
    <>
      {studentDetails?.resume?.awards?.map((item, index) => (
        <SubFLex column gap="25px" key={index+"awards"}>
          <SubFLex gap="12px">
            <div>
              <Avatar
                background="none"
                src={''}
                size={48}
                icon={<AwardsIconWork />}
                boxShadow={true}
                padding="5px"
              />
            </div>
            <SubFLex column style={{width:'90%'}}>
              <SecondaryHeading>{item.title}</SecondaryHeading>
              <SecondGreyText marginBottom="15px">
                {item.organization}
              </SecondGreyText>

              <GreyText color={COLORS.GREY_T_60}>{moment(item?.awarded_on, 'DD/MM/YYYY').format('DD MMM YYYY')}</GreyText>

              <StyledP>
                {' '}
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: item?.description || '',
                  }}
                />{' '}
              </StyledP>
              {item?.certificate && (
                <div style={{ marginTop: '12px' }}>
                  <FileReaderVisible
                    file={item.certificate}
                    showDelete={false}
                  />
                </div>
              )}
            </SubFLex>
          </SubFLex>
        </SubFLex>
      ))}
    </>
  )
}

export default AwardsSection
